export enum AuthorityPurchase {
  MOVIMENTATION_PURCHASE_PARTSLINK24 = '2.1.15',
  MOVIMENTATION_PURCHASE_VIEW_PURCHASE_GROUPS = '2.4.1',
  MOVIMENTATION_PURCHASE_SHOPPING_GROUPING = '2.4',
  MOVIMENTATION_PURCHASE_ADD_PAYMENT_METHODS = '2.1.14',
  MOVIMENTATION_PURCHASE_PRINT_PURCHASE_ORDER = '2.1.13',
  MOVIMENTATION_PURCHASE_ITEM_READ = '2.1.13',
  MOVIMENTATION_PURCHASE_ITEM_DELETE = '2.1.12',
  MOVIMENTATION_PURCHASE_ITEM_EDIT = '2.1.11',
  MOVIMENTATION_PURCHASE_ITEM_ADD = '2.1.10',
  MOVIMENTATION_PURCHASE_GENERATE_FINANCIAL_PURCHASE = '2.1.9',
  MOVIMENTATION_PURCHASE_SEND_PURCHASE_ORDER_BY_EMAIL = '2.1.8',
  MOVIMENTATION_PURCHASE_CANCEL = '2.1.7',
  MOVIMENTATION_PURCHASE_AUTHORIZE = '2.1.6',
  MOVIMENTATION_PURCHASE_PURCHASE_REPORTS = '2.1.5',
  MOVIMENTATION_PURCHASE_EDIT = '2.1.4',
  MOVIMENTATION_PURCHASE_DELETE = '2.1.3',
  MOVIMENTATION_PURCHASE_ADD = '2.1.2',
  MOVIMENTATION_PURCHASE_VIEW = '2.1.1',
  MOVIMENTATION_PURCHASE_PURCHASE_MOVEMENT = '2.1',
  MOVIMENTATION_PURCHASE_MOVIMENTATION = '2.',
  MOVIMENTATION_PURCHASE_IMPORT_XML = '2.1.16',
  MOVIMENTATION_PURCHASE_RETURN = '2.1.17',
  MOVIMENTATION_PURCHASE_ITEM_EDIT_SELL_PRICE = '2.1.18',
}
